import React, { useCallback } from 'react';
import { useStore } from '@store';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import Dropdown from 'react-bootstrap/Dropdown';
import { observer } from 'mobx-react-lite';
import Background from './Background';

const Nav = () => {
    const { pathname } = useLocation();

    const active = useCallback(
        path => classNames({ active: path === pathname }),
        [pathname]
    );
    const {
        AuthStore: { name, bhno, account },
    } = useStore();

    let bhText = '';
    switch (bhno) {
        case '1':
            bhText = '總公司';
            break;
        case '2':
            bhText = '分公司';
            break;
    }
    return (
        <>
            <header className="header d-flex flex-lg-wrap flex-nowrap justify-content-between bg-white align-items-center">
                <h1 className="h1_title d-none">
                    統一綜合證券線上隨借隨還，小額借款不求人，股票即時變現金，比銀行借款還方便
                </h1>
                <nav className="align-items-lg-end justify-content-md-between align-content-md-around w-100 d-md-flex">
                    <div className="d-flex justify-content-around align-items-center">
                        <div className="logo d-flex">
                            <a
                                href="https://www.pscnet.com.tw/pscnetStock/index.do"
                                title="統一綜合證券"
                            ></a>
                        </div>
                        <div className="logo2 d-flex position-relative">
                            <Link
                                to="/"
                                title="統一綜合證券不限用途款項借貸"
                            ></Link>
                        </div>
                        {/* UAT */}
                    </div>
                    <ul className="d-none d-md-flex justify-content-between head-nav align-items-start">
                        <li>
                            <Link to="/loan" className={active('/loan')}>
                                借款申請
                            </Link>
                        </li>
                        <li>
                            <Link className={active('/payoff')} to="/payoff">
                                還款申請
                            </Link>
                        </li>
                        <li>
                            <Link className={active('/return')} to="/return">
                                退還擔保品
                            </Link>
                        </li>
                        <li>
                            <Link
                                className={active('/accounting')}
                                to="/accounting"
                            >
                                帳務查詢
                            </Link>
                        </li>
                        <li>
                            <Link
                                className={active('/trialbalance')}
                                to="/trialbalance"
                            >
                                借款維持率試算
                            </Link>
                        </li>
                    </ul>
                </nav>

                <ul className="mo-menu d-md-none d-flex position-fixed justify-content-around">
                    <li className={active('/payoff')}>
                        <Link to="/payoff">
                            <i className="icon_m1 d-block"></i>還款
                        </Link>
                    </li>
                    <li className={active('/return')}>
                        <Link to="/return">
                            <i className="icon_m2 d-block"></i>擔保品
                        </Link>
                    </li>
                    <li className={active('/loan')}>
                        <Link
                            to="/loan"
                            className="position-relative"
                            aria-current="page"
                        >
                            借款
                        </Link>
                    </li>
                    <li className={active('/accounting')}>
                        <Link to="/accounting">
                            <i className="icon_m4 d-block"></i>帳務
                        </Link>
                    </li>
                    <li className={active('/trialbalance')}>
                        <Link to="/trialbalance">
                            <i className="icon_m5 d-block"></i>維持率
                        </Link>
                    </li>
                </ul>

                <Dropdown className="member-down d-lg-none d-flex justify-content-around align-items-center">
                    <Dropdown.Toggle className="icon_user border-0 bg-white btn-white shadow-none"></Dropdown.Toggle>
                    <Dropdown.Menu aria-labelledby="member-down">
                        <Dropdown.Item href="#" className="text-white">
                            {name}
                        </Dropdown.Item>
                        <Dropdown.Item href="#" className="text-white">
                            {bhText + account}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </header>
            <Background />
        </>
    );
};

export default observer(Nav);
